export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <path fill="${color}" d="M18.868 15.854a.502.502 0 0 0-.557-.155 5.29 5.29 0 0 1-1.79.301 5.506 5.506 0 0 1-5.5-5.5c0-1.825.9-3.524 2.41-4.546a.5.5 0 0 0-.21-.909 4.854 4.854 0 0 0-.7-.045c-4.137 0-7.5 3.364-7.5 7.5s3.363 7.5 7.5 7.5a7.445 7.445 0 0 0 6.385-3.568.503.503 0 0 0-.038-.578z"/>
</svg>
`